<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
  <div class="flex-0 flex flex-row items-center justify-between w-full">
    <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
      <div>
        <div class="inline-flex gap-x-2">
          <h3 class="text-md font-semibold text-primary m-0">SHOUT Insights</h3>
        </div>
        <p class="mt-0 text-xs text-secondary m-0">Available to Role 6</p>
      </div>
    </div>

    <div class="flex flex-row items-center justify-end gap-x-4">
      <div class="grid grid-cols-1 sm:hidden">
        <select
          aria-label="Select insights section"
          class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-sm text-primary outline-1 -outline-offset-1 outline-zinc-200 dark:bg-zinc-900 dark:outline-zinc-700"
          [value]="activeNavRoute()"
          (change)="selectNavMobile($event)">
          @for (item of navItems(); track item.route) {
            <option [value]="item.route">{{ item.label }}</option>
          }
        </select>
      </div>

      <nav aria-label="Insights sections" class="hidden sm:flex space-x-2">
        @for (item of navItems(); track item.route) {
          <button
            type="button"
            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
            [class]="getNavButtonClass(item)"
            (click)="goToNavItem(item)">
            {{ item.label }}
          </button>
        }
      </nav>
    </div>
  </div>

  <div class="h-full min-h-0 flex-1 flex flex-col w-full overflow-hidden">
    <router-outlet />
  </div>
</div>
